
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class HomeBannerTemplate extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly description!: string;

  image: string = require('@/assets/img/image-banner-information.png');
}
